const dict = {
  th: {
    title: 'วิดีโอเรียลไทม์ (v2)',
    stop: 'หยุดทั้งหมด',
    fullscreen: 'ขยายเต็มจอ',
    filter: 'ตัวกรอง',

    emptyCell: 'เลือกรถจากรายการด้านซ้าย',
    starting: 'กำลังสั่งเปิดกล้อง…',
    connecting: 'กำลังเชื่อมต่อ…',
    connectingFor: 'กำลังเชื่อมต่อ… {sec} วิ',
    stalled: 'ภาพหยุดเดิน',
    offline: 'อุปกรณ์ไม่ส่งภาพ',
    stopped: 'หยุดแล้ว',
    unknownState: 'ไม่ทราบสถานะ',
    unknownHint: 'ผู้ให้บริการรายนี้ไม่ส่งสถานะกลับมา',

    camera: 'กล้อง',
    cameraFallback: 'CH{n}',
    slot: 'ช่อง {n}',
    mute: 'ปิดเสียง',
    unmute: 'เปิดเสียง',

    retry: 'ลองใหม่',
    tapToPlay: 'แตะเพื่อเล่น',
    close: 'ปิดกรอบ',
    copyDetail: 'คัดลอกรายละเอียดส่ง IT',
    copied: 'คัดลอกแล้ว',
    speedUnit: 'KB/s',

    // รายการรถและหน้าต่างตัวกรอง — คำเดียวกับหน้าเดิม
    plateNo: 'ทะเบียน',
    vehicleStatusColumn: 'สถานะ',
    gpsVendor: 'GPS Vendor',
    streamTag: 'ติดตั้ง 2026',
    streamHint: 'เล่นวิดีโอบนหน้านี้โดยตรง ไม่ผ่านหน้าเว็บผู้ให้บริการ',
    filterTitle: 'ค้นหา',
    ok: 'ตกลง',
    cancel: 'ยกเลิก',
    vehicleStatusLabel: 'สถานะพาหนะ',
    division: 'กิจการ',
    department: 'ฝ่ายส่วน',
    section: 'แผนก',
    plant: 'โรงงาน',
    vehicleLabel: 'พาหนะ',
    itemLeft: 'เหลือ',
    itemSelected: 'เลือก',
    vehicleStatus: {
      running: 'วิ่ง',
      'stop-with-engine-on': 'จอดไม่ดับเครื่อง',
      'stop-with-engine-off': 'ดับเครื่อง',
      'connection-error': 'ขาดการติดต่อ',
    },

    errors: {
      vehicle_not_found: 'ไม่พบรถคันนี้ในระบบ',
      no_permission: 'ไม่มีสิทธิ์ดูรถคันนี้',
      unsupported_device: 'อุปกรณ์รุ่นนี้ยังไม่รองรับการดูสด',
      camera_not_found: 'ไม่มีข้อมูลกล้องของรถคันนี้',
      device_offline: 'อุปกรณ์ไม่ออนไลน์',
      device_status_unknown: 'ไม่ทราบสถานะอุปกรณ์ ลองใหม่อีกครั้ง',
      device_no_video: 'อุปกรณ์ไม่ส่งภาพ',
      device_busy: 'อุปกรณ์ไม่ว่าง ลองใหม่อีกครั้ง',
      stream_limit_reached: 'มีผู้ชมเต็มแล้ว ลองใหม่อีกครั้ง',
      session_not_found: 'session หมดอายุ ลองใหม่',
      session_ended: 'session จบแล้ว ลองใหม่',
      quality_not_supported: 'อุปกรณ์นี้ไม่มีภาพแบบประหยัดเน็ต',
      vendor_timeout: 'ผู้ให้บริการไม่ตอบในเวลาที่กำหนด',
      vendor_error: 'ผู้ให้บริการตอบกลับผิดพลาด',
      invalid_request: 'คำขอไม่ถูกต้อง',
      unauthorized: 'หมดเวลาใช้งาน กรุณาเข้าสู่ระบบใหม่',
      rate_limited: 'เรียกถี่เกินไป รอสักครู่',
      server_error: 'ระบบขัดข้อง',
      service_unavailable: 'ระบบไม่พร้อมให้บริการชั่วคราว ลองใหม่อีกครั้ง',
      internal_error: 'ระบบขัดข้อง ลองใหม่อีกครั้ง',
      timeout: 'ระบบไม่ตอบในเวลาที่กำหนด',
      network_error: 'เชื่อมต่อระบบไม่ได้',
      no_first_frame: 'อุปกรณ์ไม่ส่งภาพ',
      unsupported: 'เบราว์เซอร์นี้เล่นวิดีโอรูปแบบนี้ไม่ได้',
      unknown_protocol: 'รูปแบบวิดีโอที่ไม่รู้จัก',
      hls_error: 'เล่นวิดีโอไม่ได้',
      not_found: 'ไม่พบข้อมูลที่ขอ',
      http_error: 'ระบบตอบกลับผิดพลาด',
      source_failed: 'เปิดวิดีโอไม่ได้ (ลิงก์ใช้ไม่ได้ หรือรูปแบบไม่รองรับ)',
      autoplay_blocked: 'เบราว์เซอร์ไม่ยอมเล่นวิดีโออัตโนมัติ',
      networkError: 'โหลดวิดีโอไม่ได้ (เครือข่าย)',
      mediaError: 'ถอดรหัสวิดีโอไม่ได้',
      muxError: 'ถอดรหัสวิดีโอไม่ได้',
      keySystemError: 'ถอดรหัสวิดีโอไม่ได้',
      otherError: 'เล่นวิดีโอไม่ได้',
      NetworkError: 'โหลดวิดีโอไม่ได้ (เครือข่าย)',
      MediaError: 'ถอดรหัสวิดีโอไม่ได้',
      OtherError: 'เล่นวิดีโอไม่ได้',
    },
    errorHints: {
      no_first_frame: 'ไม่มีภาพเข้ามาภายในเวลาที่กำหนด',
      unauthorized: 'กด F5 แล้วเข้าสู่ระบบใหม่',
      autoplay_blocked: 'กดปุ่มด้านล่างเพื่อเริ่มเล่น',
    },
    endReason: {
      client_stop: 'หยุดโดยผู้ใช้',
      idle_timeout: 'ไม่มีการตอบรับ ระบบจึงหยุดสตรีม',
      vendor_ended: 'ผู้ให้บริการหยุดสตรีม',
      expired: 'session หมดอายุ',
      error: 'สตรีมถูกตัดเพราะข้อผิดพลาด',
    },
  },
  en: {
    title: 'Live Stream (v2)',
    stop: 'Stop all',
    fullscreen: 'Fullscreen',
    filter: 'Filter',

    emptyCell: 'Select a vehicle from the list',
    starting: 'Requesting camera…',
    connecting: 'Connecting…',
    connectingFor: 'Connecting… {sec}s',
    stalled: 'Video stalled',
    offline: 'Device not sending video',
    stopped: 'Stopped',
    unknownState: 'Status unknown',
    unknownHint: 'This provider does not report status',

    camera: 'Camera',
    cameraFallback: 'CH{n}',
    slot: 'Slot {n}',
    mute: 'Mute',
    unmute: 'Unmute',

    retry: 'Retry',
    tapToPlay: 'Tap to play',
    close: 'Close cell',
    copyDetail: 'Copy details for IT',
    copied: 'Copied',
    speedUnit: 'KB/s',

    plateNo: 'Plate No.',
    vehicleStatusColumn: 'Status',
    gpsVendor: 'GPS Vendor',
    streamTag: 'Installed 2026',
    streamHint: "Plays here directly, not through the provider's web page",
    filterTitle: 'Filter',
    ok: 'OK',
    cancel: 'Cancel',
    vehicleStatusLabel: 'Vehicle Status',
    division: 'Division',
    department: 'Department',
    section: 'Section',
    plant: 'Plant',
    vehicleLabel: 'Vehicle',
    itemLeft: 'Not Select',
    itemSelected: 'Select',
    vehicleStatus: {
      running: 'Running',
      'stop-with-engine-on': 'Stop/Engine On',
      'stop-with-engine-off': 'Engine Off',
      'connection-error': 'Disconnected',
    },

    errors: {
      vehicle_not_found: 'Vehicle not found',
      no_permission: 'No permission to view this vehicle',
      unsupported_device: 'This device model does not support live view',
      camera_not_found: 'No camera data for this vehicle',
      device_offline: 'Device offline',
      device_status_unknown: 'Device status unknown, try again',
      device_no_video: 'Device not sending video',
      device_busy: 'Device busy, try again',
      stream_limit_reached: 'Viewer limit reached, try again',
      session_not_found: 'Session expired, retry',
      session_ended: 'Session ended, retry',
      quality_not_supported: 'This device has no low-data stream',
      vendor_timeout: 'Provider did not respond in time',
      vendor_error: 'Provider returned an error',
      invalid_request: 'Invalid request',
      unauthorized: 'Session expired, please sign in again',
      rate_limited: 'Too many requests, wait a moment',
      server_error: 'Service error',
      service_unavailable: 'Service temporarily unavailable, try again',
      internal_error: 'Service error, try again',
      timeout: 'Service did not respond in time',
      network_error: 'Cannot reach the service',
      no_first_frame: 'Device not sending video',
      unsupported: 'This browser cannot play this video format',
      unknown_protocol: 'Unknown video format',
      hls_error: 'Cannot play video',
      not_found: 'Requested resource not found',
      http_error: 'Service returned an error',
      source_failed: 'Cannot open video (link failed or format not supported)',
      autoplay_blocked: 'The browser blocked autoplay',
      networkError: 'Cannot load video (network)',
      mediaError: 'Cannot decode video',
      muxError: 'Cannot decode video',
      keySystemError: 'Cannot decode video',
      otherError: 'Cannot play video',
      NetworkError: 'Cannot load video (network)',
      MediaError: 'Cannot decode video',
      OtherError: 'Cannot play video',
    },
    errorHints: {
      no_first_frame: 'No video arrived in time',
      unauthorized: 'Press F5 and sign in again',
      autoplay_blocked: 'Press the button below to start playback',
    },
    endReason: {
      client_stop: 'Stopped by user',
      idle_timeout: 'No response, stream was stopped',
      vendor_ended: 'Provider ended the stream',
      expired: 'Session expired',
      error: 'Stream cut by an error',
    },
  },
}

export function fill(template, vars) {
  return String(template).replace(/\{(\w+)\}/g, (_, k) =>
    vars[k] === undefined ? '' : String(vars[k]),
  )
}

export default function t(language) {
  return dict[language] || dict.th
}
